import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Badge, Text } from '@rneui/themed';

const DailyComments = ({ dailyComments, total }) => {
  return dailyComments.map((c) => (
    <View key={c.date}>
      <View style={styles.headerView}>
        <Text style={styles.dateText}>{c.date}</Text>
        <Badge value={total.daily[c.date]} status="primary" />
      </View>
      <Text style={styles.commentText}>{c.comment}</Text>
    </View>
  ));
};

const styles = StyleSheet.create({
  dateText: {
    fontSize: 14,
    fontWeight: 'bold',
    color: 'grey',
    marginBottom: 2,
    marginRight: 10,
  },
  commentText: {
    marginBottom: 7,
  },
  headerView: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default DailyComments;
